// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/idp_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_client } from "../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../google/api/resource_pb";
import type { EmptySchema, FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/idp_service.proto.
 */
export const file_api_v1_idp_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_field_mask]);

/**
 * @generated from message journal.api.v1.IdentityProvider
 */
export type IdentityProvider = Message<"journal.api.v1.IdentityProvider"> & {
  /**
   * The resource name of the identity provider.
   * Format: identity-providers/{idp}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Required. The type of the identity provider.
   *
   * @generated from field: journal.api.v1.IdentityProvider.Type type = 2;
   */
  type: IdentityProvider_Type;

  /**
   * Required. The display title of the identity provider.
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Optional. Filter applied to user identifiers.
   *
   * @generated from field: string identifier_filter = 4;
   */
  identifierFilter: string;

  /**
   * Required. Configuration for the identity provider.
   *
   * @generated from field: journal.api.v1.IdentityProviderConfig config = 5;
   */
  config?: IdentityProviderConfig;
};

/**
 * Describes the message journal.api.v1.IdentityProvider.
 * Use `create(IdentityProviderSchema)` to create a new message.
 */
export const IdentityProviderSchema: GenMessage<IdentityProvider> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 0);

/**
 * @generated from enum journal.api.v1.IdentityProvider.Type
 */
export enum IdentityProvider_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  TYPE_UNSPECIFIED = 0,

  /**
   * OAuth2 identity provider.
   *
   * @generated from enum value: OAUTH2 = 1;
   */
  OAUTH2 = 1,
}

/**
 * Describes the enum journal.api.v1.IdentityProvider.Type.
 */
export const IdentityProvider_TypeSchema: GenEnum<IdentityProvider_Type> = /*@__PURE__*/
  enumDesc(file_api_v1_idp_service, 0, 0);

/**
 * @generated from message journal.api.v1.IdentityProviderConfig
 */
export type IdentityProviderConfig = Message<"journal.api.v1.IdentityProviderConfig"> & {
  /**
   * @generated from oneof journal.api.v1.IdentityProviderConfig.config
   */
  config: {
    /**
     * @generated from field: journal.api.v1.OAuth2Config oauth2_config = 1;
     */
    value: OAuth2Config;
    case: "oauth2Config";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message journal.api.v1.IdentityProviderConfig.
 * Use `create(IdentityProviderConfigSchema)` to create a new message.
 */
export const IdentityProviderConfigSchema: GenMessage<IdentityProviderConfig> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 1);

/**
 * @generated from message journal.api.v1.FieldMapping
 */
export type FieldMapping = Message<"journal.api.v1.FieldMapping"> & {
  /**
   * @generated from field: string identifier = 1;
   */
  identifier: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;
};

/**
 * Describes the message journal.api.v1.FieldMapping.
 * Use `create(FieldMappingSchema)` to create a new message.
 */
export const FieldMappingSchema: GenMessage<FieldMapping> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 2);

/**
 * @generated from message journal.api.v1.OAuth2Config
 */
export type OAuth2Config = Message<"journal.api.v1.OAuth2Config"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * @generated from field: string auth_url = 3;
   */
  authUrl: string;

  /**
   * @generated from field: string token_url = 4;
   */
  tokenUrl: string;

  /**
   * @generated from field: string user_info_url = 5;
   */
  userInfoUrl: string;

  /**
   * @generated from field: repeated string scopes = 6;
   */
  scopes: string[];

  /**
   * @generated from field: journal.api.v1.FieldMapping field_mapping = 7;
   */
  fieldMapping?: FieldMapping;
};

/**
 * Describes the message journal.api.v1.OAuth2Config.
 * Use `create(OAuth2ConfigSchema)` to create a new message.
 */
export const OAuth2ConfigSchema: GenMessage<OAuth2Config> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 3);

/**
 * @generated from message journal.api.v1.ListIdentityProvidersRequest
 */
export type ListIdentityProvidersRequest = Message<"journal.api.v1.ListIdentityProvidersRequest"> & {
};

/**
 * Describes the message journal.api.v1.ListIdentityProvidersRequest.
 * Use `create(ListIdentityProvidersRequestSchema)` to create a new message.
 */
export const ListIdentityProvidersRequestSchema: GenMessage<ListIdentityProvidersRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 4);

/**
 * @generated from message journal.api.v1.ListIdentityProvidersResponse
 */
export type ListIdentityProvidersResponse = Message<"journal.api.v1.ListIdentityProvidersResponse"> & {
  /**
   * The list of identity providers.
   *
   * @generated from field: repeated journal.api.v1.IdentityProvider identity_providers = 1;
   */
  identityProviders: IdentityProvider[];
};

/**
 * Describes the message journal.api.v1.ListIdentityProvidersResponse.
 * Use `create(ListIdentityProvidersResponseSchema)` to create a new message.
 */
export const ListIdentityProvidersResponseSchema: GenMessage<ListIdentityProvidersResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 5);

/**
 * @generated from message journal.api.v1.GetIdentityProviderRequest
 */
export type GetIdentityProviderRequest = Message<"journal.api.v1.GetIdentityProviderRequest"> & {
  /**
   * Required. The resource name of the identity provider to get.
   * Format: identity-providers/{idp}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.GetIdentityProviderRequest.
 * Use `create(GetIdentityProviderRequestSchema)` to create a new message.
 */
export const GetIdentityProviderRequestSchema: GenMessage<GetIdentityProviderRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 6);

/**
 * @generated from message journal.api.v1.CreateIdentityProviderRequest
 */
export type CreateIdentityProviderRequest = Message<"journal.api.v1.CreateIdentityProviderRequest"> & {
  /**
   * Required. The identity provider to create.
   *
   * @generated from field: journal.api.v1.IdentityProvider identity_provider = 1;
   */
  identityProvider?: IdentityProvider;

  /**
   * Optional. The ID to use for the identity provider, which will become the final component of the resource name.
   * If not provided, the system will generate one.
   *
   * @generated from field: string identity_provider_id = 2;
   */
  identityProviderId: string;
};

/**
 * Describes the message journal.api.v1.CreateIdentityProviderRequest.
 * Use `create(CreateIdentityProviderRequestSchema)` to create a new message.
 */
export const CreateIdentityProviderRequestSchema: GenMessage<CreateIdentityProviderRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 7);

/**
 * @generated from message journal.api.v1.UpdateIdentityProviderRequest
 */
export type UpdateIdentityProviderRequest = Message<"journal.api.v1.UpdateIdentityProviderRequest"> & {
  /**
   * Required. The identity provider to update.
   *
   * @generated from field: journal.api.v1.IdentityProvider identity_provider = 1;
   */
  identityProvider?: IdentityProvider;

  /**
   * Required. The update mask applies to the resource. Only the top level fields of
   * IdentityProvider are supported.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateIdentityProviderRequest.
 * Use `create(UpdateIdentityProviderRequestSchema)` to create a new message.
 */
export const UpdateIdentityProviderRequestSchema: GenMessage<UpdateIdentityProviderRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 8);

/**
 * @generated from message journal.api.v1.DeleteIdentityProviderRequest
 */
export type DeleteIdentityProviderRequest = Message<"journal.api.v1.DeleteIdentityProviderRequest"> & {
  /**
   * Required. The resource name of the identity provider to delete.
   * Format: identity-providers/{idp}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeleteIdentityProviderRequest.
 * Use `create(DeleteIdentityProviderRequestSchema)` to create a new message.
 */
export const DeleteIdentityProviderRequestSchema: GenMessage<DeleteIdentityProviderRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_idp_service, 9);

/**
 * @generated from service journal.api.v1.IdentityProviderService
 */
export const IdentityProviderService: GenService<{
  /**
   * ListIdentityProviders lists identity providers.
   *
   * @generated from rpc journal.api.v1.IdentityProviderService.ListIdentityProviders
   */
  listIdentityProviders: {
    methodKind: "unary";
    input: typeof ListIdentityProvidersRequestSchema;
    output: typeof ListIdentityProvidersResponseSchema;
  },
  /**
   * GetIdentityProvider gets an identity provider.
   *
   * @generated from rpc journal.api.v1.IdentityProviderService.GetIdentityProvider
   */
  getIdentityProvider: {
    methodKind: "unary";
    input: typeof GetIdentityProviderRequestSchema;
    output: typeof IdentityProviderSchema;
  },
  /**
   * CreateIdentityProvider creates an identity provider.
   *
   * @generated from rpc journal.api.v1.IdentityProviderService.CreateIdentityProvider
   */
  createIdentityProvider: {
    methodKind: "unary";
    input: typeof CreateIdentityProviderRequestSchema;
    output: typeof IdentityProviderSchema;
  },
  /**
   * UpdateIdentityProvider updates an identity provider.
   *
   * @generated from rpc journal.api.v1.IdentityProviderService.UpdateIdentityProvider
   */
  updateIdentityProvider: {
    methodKind: "unary";
    input: typeof UpdateIdentityProviderRequestSchema;
    output: typeof IdentityProviderSchema;
  },
  /**
   * DeleteIdentityProvider deletes an identity provider.
   *
   * @generated from rpc journal.api.v1.IdentityProviderService.DeleteIdentityProvider
   */
  deleteIdentityProvider: {
    methodKind: "unary";
    input: typeof DeleteIdentityProviderRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_idp_service, 0);

